import { create } from "zustand";
import { modesToAssisstantName } from "@/constants";
import { createUpdater } from ".";
// Create a specialized updater for MainLayoutState
const mainLayoutUpdater = createUpdater();
export const useMainLayoutStore = create((set) => ({
    // Initial state
    showSidebar: false,
    showChatInterface: true,
    modeFullScreen: false,
    currentHostMode: "",
    modesHistory: [],
    showModeOnboarding: false,
    activeMode: "",
    modeList: [],
    project: null,
    showInstantSidebar: false,
    sidebarType: null,
    modeNameToAssistantName: modesToAssisstantName,
    recentConversations: [],
    isWidgetTypeChange: false,
    isUserOnboarded: false,
    isCurrentHostChanged: false,
    remoteLoadedInfo: {
        modeName: "",
        isLoaded: false,
    },
    hostLoadedInfo: {
        modeName: "",
        isLoaded: false,
    },
    pendingArtifactData: null,
    pendingUserData: { modeName: "", userData: null },
    pendingArtifactDataFromHost: null,
    manualSelectionData: {
        isSelected: false,
        modeName: "",
    },
    streamingMessages: [],
    pendingSubModeData: null,
    // Actions
    setShowSidebar: mainLayoutUpdater("showSidebar")(set),
    setShowChatInterface: mainLayoutUpdater("showChatInterface")(set),
    setModeFullScreen: mainLayoutUpdater("modeFullScreen")(set),
    setCurrentHostMode: mainLayoutUpdater("currentHostMode")(set),
    setModesHistory: mainLayoutUpdater("modesHistory")(set),
    setShowModeOnboarding: mainLayoutUpdater("showModeOnboarding")(set),
    setActiveMode: mainLayoutUpdater("activeMode")(set),
    setModeList: mainLayoutUpdater("modeList")(set),
    setProject: mainLayoutUpdater("project")(set),
    setShowInstantSidebar: mainLayoutUpdater("showInstantSidebar")(set),
    setSidebarType: mainLayoutUpdater("sidebarType")(set),
    setModeNameToAssistantName: mainLayoutUpdater("modeNameToAssistantName")(set),
    setRecentConversations: mainLayoutUpdater("recentConversations")(set),
    setIsWidgetTypeChange: mainLayoutUpdater("isWidgetTypeChange")(set),
    setIsUserOnboarded: mainLayoutUpdater("isUserOnboarded")(set),
    setIsCurrentHostChanged: mainLayoutUpdater("isCurrentHostChanged")(set),
    setRemoteLoadedInfo: mainLayoutUpdater("remoteLoadedInfo")(set),
    setHostLoadedInfo: mainLayoutUpdater("hostLoadedInfo")(set),
    setPendingArtifactData: mainLayoutUpdater("pendingArtifactData")(set),
    setPendingUserData: mainLayoutUpdater("pendingUserData")(set),
    setPendingArtifactDataFromHost: mainLayoutUpdater("pendingArtifactDataFromHost")(set),
    setManualSelectionData: mainLayoutUpdater("manualSelectionData")(set),
    setStreamingMessages: mainLayoutUpdater("streamingMessages")(set),
    setPendingSubModeData: mainLayoutUpdater("pendingSubModeData")(set),
}));
